<template lang="pug">
  .w-100.mh-100.h-100
    dx-data-grid(ref="grid"
    :data-source='reportSummary'
    :selection="{ mode: 'single' }"
    :show-borders='true'
    :style="{ height: localHeight, width: localWidth }"
    :columns="!reportData.IsSummary ? fields : fieldsSummary"
    :summary="summary"
    :row-alternation-enabled="true"
    :allow-column-reordering="true"
    :allow-column-dragging="false"
    @content-ready="onContentReady"
    @cell-click="onSelectionChanged")
      dx-scrolling(mode='virtual', :useNative="false")
      dx-sorting(mode="multiple")
      dx-load-panel(:enabled="true")
      dx-header-filter(:visible="true")
      dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';
import { SETTINGS_EVENTS } from '~/consts/eventTypes';

export default {
  name: 'EngineHoursGrouped',
  components: {
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
    track: {
      type: Object,
      default () {
        return {};
      },
    },
    colors: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'Date',
        caption: 'Дата',
        fixed: true,
        width: 25,
        customizeText: params => new Date(params.value * 1000).toLocaleDateString('ru', { timeZone: 'UTC' }),
        groupIndex: 0,
      }, {
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'Begin',
        caption: 'Начало',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 120,
      }, {
        dataField: 'End',
        caption: 'Конец',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 120,
      }, {
        dataField: 'BeginLocation',
        caption: 'Начальное положение',
      }, {
        dataField: 'EndLocation',
        caption: 'Конечное положение',
      }, {
        dataField: 'EngineHoursText',
        caption: 'Моточасы',
        alignment: 'center',
        width: 130,
      }, {
        dataField: 'EngineHoursInParkingsText',
        caption: 'Моточасы в стоянках',
        alignment: 'center',
        width: 130,
      }, {
        dataField: 'EngineHoursInRidesText',
        caption: 'Моточасы в поездках',
        alignment: 'center',
        width: 130,
      }],
      detailColoumn: [{
        column: 'RowNum',
        displayFormat: 'Итого:',
      }, {
        column: 'BeginLocation',
        name: 'BeginLocation',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'EndLocation',
        name: 'EndLocation',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'EngineHoursText',
        name: 'EngineHoursText',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'EngineHoursInParkingsText',
        name: 'EngineHoursInParkingsText',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'EngineHoursInRidesText',
        name: 'EngineHoursInRidesText',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      fieldsSummary: [{
        dataField: 'Date',
        caption: 'Дата',
        fixed: true,
        width: 25,
        customizeText: params => new Date(params.value * 1000).toLocaleDateString('ru', { timeZone: 'UTC' }),
        groupIndex: 0,
      }, {
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
      }, {
        dataField: 'ObjectName',
        caption: 'Объект',
      }, {
        dataField: 'EngineHoursText',
        caption: 'Моточасы',
        alignment: 'center',
        width: 130,
      }, {
        dataField: 'EngineHoursInParkingsText',
        caption: 'Моточасы в стоянках',
        alignment: 'center',
        width: 130,
      }, {
        dataField: 'EngineHoursInRidesText',
        caption: 'Моточасы в поездках',
        alignment: 'center',
        width: 130,
      }],
      summaryColoumn: [{
        column: 'RowNum',
        displayFormat: 'Итого:',
      }, {
        column: 'EngineHoursText',
        name: 'SumEngineHoursText',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'EngineHoursInParkingsText',
        name: 'SumEngineHoursInParkingsText',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }, {
        column: 'EngineHoursInRidesText',
        name: 'SumEngineHoursInRidesText',
        summaryType: 'custom',
        displayFormat: '{0}',
        alignByColumn: true,
        showInGroupFooter: false,
      }],
      summary: null,
      rowClick: null,
      reportSummary: [],
      index: 0,
    };
  },
  watch: {
    reportData (value) {
      this.rowClick = null;
      this.convertData(this.reportData);
      this.getSummary();
      this.getAddresses();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    this.convertData(this.reportData);
    this.getSummary();
    this.getAddresses();
    this.$eventBus.subscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
      this.getAddresses,
    );
  },
  beforeDestroy () {
    this.$eventBus.unsubscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
    );
  },
  methods: {
    onSelectionChanged (item) {
      if (item.rowType === 'data') {
        if (this.reportData.BuildTrack && this.track.Id) {
          if (!(this.rowClick && this.rowClick.Begin === item.data.Begin && this.rowClick.End === item.data.End)) {
            const timeZone = Number(this.reportData.TimeZone.split(':', 3)[0]);
            const periods = [[new Date((item.data.Begin - timeZone * 3600) * 1000), new Date((item.data.End - timeZone * 3600) * 1000)]];
            this.$store.dispatch('tracks/updateTrack', { reportId: this.track.Id, secondColor: this.colors.alternative.hex, periods });
            this.reportData.periodsPartTrack = periods;
            this.rowClick = {
              Begin: item.data.Begin,
              End: item.data.End,
            };
          }
        }
        if (item.column.dataField === 'Begin' || item.column.dataField === 'BeginLocation') {
          const value = {
            lat: item.data.BeginLocationLatitude,
            lng: item.data.BeginLocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
        if (item.column.dataField === 'End' || item.column.dataField === 'EndLocation') {
          const value = {
            lat: item.data.EndLocationLatitude,
            lng: item.data.EndLocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
      }
    },

    convertData (data) {
      if (this.reportData.IsSummary) {
        let rows = [];
        data.Data.Data.forEach((_items, i) => {
          const items = _items;
          items.RowNum = i + 1;

          items.Group = i;
          items.Begin = null;
          items.End = null;
          items.Rows.forEach((_row, j) => {
            const item = _row;
            item.Group = i;
            item.RowNum = j + 1;
            item.Date = items.Date;
            item.SumEngineHoursText = items.SumEngineHoursText;
          });
          rows = rows.concat(items.Rows);
        });
        this.reportSummary = rows;
      } else {
        let rows = [];
        data.Data.Data.Rows.forEach((_group, i) => {
          const group = _group;
          group.Group = i;
          group.RowNum = i + 1;

          group.Rows.forEach((_item, j) => {
            const item = _item;
            item.Group = i;
            item.RowNum = j + 1;
            item.Date = group.Date;
          });
          rows = rows.concat(group.Rows);
        });
        this.reportSummary = rows;
      }
    },
    getSummary () {
      if (!this.reportData.IsSummary) {
        this.summary = {
          calculateCustomSummary: (options) => {
            if (options.summaryProcess === 'finalize') {
              if (!this.reportData.Data.Data.Rows[this.index]) {
                this.index = 0;
              }
              const value = options;
              if (options.groupIndex !== undefined) {
                const totalValue = this.reportData.Data.Data.Rows[this.index][options.name];
                if (totalValue !== undefined) {
                  value.totalValue = totalValue;
                }
                if (options.name === 'EngineHoursInRidesText') {
                  this.index += 1;
                }
              } else {
                const totalValue = this.reportData.Data.Data[`Sum${options.name}`];
                if (totalValue !== undefined) {
                  value.totalValue = totalValue;
                }
              }
            }
          },
          totalItems: this.detailColoumn.filter(x => x.column === 'RowNum' || x.column === 'EngineHoursText' || x.column === 'EngineHoursInParkingsText' || x.column === 'EngineHoursInRidesText'),
          groupItems: this.detailColoumn.filter(x => x.column !== 'RowNum'),
        };
      } else {
        this.summary = {
          calculateCustomSummary: (options) => {
            const value = options;
            if (options.summaryProcess === 'finalize') {
              const data = this.reportData.Data.Data.filter(arr => arr.Rows.length > 0);
              if (!data[this.index]) {
                this.index = 0;
              }
              if (options.groupIndex === 0) {
                value.totalValue = data[this.index] ? data[this.index][`${options.name}`] : undefined;
                if (options.name === 'SumEngineHoursInRidesText') {
                  this.index += 1;
                }
              }
            } else if (options.groupIndex === undefined) {
              const totalValue = this.reportData.Data[options.name];
              if (totalValue !== undefined) {
                value.totalValue = totalValue;
              }
            }
          },
          totalItems: this.summaryColoumn,
          groupItems: this.summaryColoumn.filter(x => x.column !== 'RowNum'),
        };
      }
    },

    getAddresses () {
      if (this.reportData.State === 'Done' || this.reportData.State === 'OK') {
        if (!this.reportData.IsSummary) {
          this.reportData.Data.Data.Rows.forEach((row) => {
            this.getAddress(row.BeginLocationLatitude, row.BeginLocationLongitude, row, true);
            this.getAddress(row.EndLocationLatitude, row.EndLocationLongitude, row, false);
            row.Rows.forEach((rows) => {
              this.getAddress(rows.BeginLocationLatitude, rows.BeginLocationLongitude, rows, true);
              this.getAddress(rows.EndLocationLatitude, rows.EndLocationLongitude, rows, false);
            });
          });
        }
      }
    },
    getAddress (lat, lon, _row, begin) {
      const row = _row;
      const location = begin ? 'BeginLocation' : 'EndLocation';
      row[location] = null;
      setImmediate(async () => {
        const address = await this.$store.dispatch('nominatim/getAddress', { lat, lon });
        row[location] = address;
      });
    },
  },
};
</script>
